import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12fb0ecc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "mini-player",
  "aria-label": "快捷音乐控制"
};
const _hoisted_2 = {
  class: "mini-copy"
};
const _hoisted_3 = {
  class: "mini-controls"
};
const _hoisted_4 = ["disabled", "aria-label"];
const _hoisted_5 = ["aria-expanded", "aria-label"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "beat-ring"
}, null, -1));
const _hoisted_7 = ["src"];
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ArrowLeft, ArrowRight, Loading, RefreshRight, VideoPause, VideoPlay } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import musicCat from "@/assets/images/music-cat-headphones.png";
import { useMusicPlayer } from "@/composables/useMusicPlayer";
export default {
  __name: 'GlobalMusicPlayer',
  setup(__props) {
    const route = useRoute();
    const isStudio = computed(() => ["writeArticle", "editArticleById"].includes(route.name));
    const audioRef = ref(null);
    const expanded = ref(false);
    const {
      currentSong,
      hasActiveSong,
      hasPlaybackStarted,
      isPlaying,
      isBuffering,
      audioFailed,
      retryingAudio,
      bindAudio,
      togglePlayback,
      previousTrack,
      nextTrack,
      handleMetadata,
      handleTimeUpdate,
      handleSeeked,
      handlePlaying,
      handlePause,
      handleEnded,
      handleAudioError
    } = useMusicPlayer();
    function handleEscape(event) {
      if (event.key === "Escape") expanded.value = false;
    }
    onMounted(() => {
      bindAudio(audioRef.value);
      window.addEventListener("keydown", handleEscape);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("keydown", handleEscape);
      bindAudio(null);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("audio", {
        ref_key: "audioRef",
        ref: audioRef,
        preload: "metadata",
        onLoadedmetadata: _cache[0] || (_cache[0] = (...args) => _unref(handleMetadata) && _unref(handleMetadata)(...args)),
        onDurationchange: _cache[1] || (_cache[1] = (...args) => _unref(handleMetadata) && _unref(handleMetadata)(...args)),
        onTimeupdate: _cache[2] || (_cache[2] = (...args) => _unref(handleTimeUpdate) && _unref(handleTimeUpdate)(...args)),
        onSeeking: _cache[3] || (_cache[3] = $event => isBuffering.value = true),
        onSeeked: _cache[4] || (_cache[4] = (...args) => _unref(handleSeeked) && _unref(handleSeeked)(...args)),
        onWaiting: _cache[5] || (_cache[5] = $event => isBuffering.value = true),
        onCanplay: _cache[6] || (_cache[6] = $event => isBuffering.value = false),
        onPlaying: _cache[7] || (_cache[7] = (...args) => _unref(handlePlaying) && _unref(handlePlaying)(...args)),
        onPause: _cache[8] || (_cache[8] = (...args) => _unref(handlePause) && _unref(handlePause)(...args)),
        onEnded: _cache[9] || (_cache[9] = (...args) => _unref(handleEnded) && _unref(handleEnded)(...args)),
        onError: _cache[10] || (_cache[10] = (...args) => _unref(handleAudioError) && _unref(handleAudioError)(...args))
      }, null, 544), _unref(hasActiveSong) && (_unref(hasPlaybackStarted) || _unref(audioFailed) || _unref(retryingAudio)) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["global-music", {
          playing: _unref(isPlaying),
          expanded: expanded.value,
          'in-studio': isStudio.value
        }])
      }, [_createVNode(_Transition, {
        name: "player-panel"
      }, {
        default: _withCtx(() => [expanded.value ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_unref(retryingAudio) ? "重新加载中…" : _unref(audioFailed) ? "播放失败 · 点击重试" : _unref(isPlaying) ? "NOW PLAYING" : "PAUSED"), 1), _createElementVNode("strong", null, _toDisplayString(_unref(currentSong).title || "未命名曲目"), 1), _createElementVNode("small", null, _toDisplayString(_unref(currentSong).artist || "未知音乐人"), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
          type: "button",
          "aria-label": "上一首",
          onClick: _cache[11] || (_cache[11] = _withModifiers((...args) => _unref(previousTrack) && _unref(previousTrack)(...args), ["stop"]))
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
          _: 1
        })]), _createElementVNode("button", {
          class: "mini-play",
          type: "button",
          disabled: _unref(retryingAudio),
          "aria-label": _unref(retryingAudio) ? '正在重新加载' : _unref(audioFailed) ? '重新加载并播放' : _unref(isPlaying) ? '暂停' : '播放',
          onClick: _cache[12] || (_cache[12] = _withModifiers((...args) => _unref(togglePlayback) && _unref(togglePlayback)(...args), ["stop"]))
        }, [_createVNode(_component_el_icon, {
          class: _normalizeClass({
            'is-loading': _unref(retryingAudio)
          })
        }, {
          default: _withCtx(() => [_unref(retryingAudio) ? (_openBlock(), _createBlock(_unref(Loading), {
            key: 0
          })) : _unref(audioFailed) ? (_openBlock(), _createBlock(_unref(RefreshRight), {
            key: 1
          })) : _unref(isPlaying) ? (_openBlock(), _createBlock(_unref(VideoPause), {
            key: 2
          })) : (_openBlock(), _createBlock(_unref(VideoPlay), {
            key: 3
          }))]),
          _: 1
        }, 8, ["class"])], 8, _hoisted_4), _createElementVNode("button", {
          type: "button",
          "aria-label": "下一首",
          onClick: _cache[13] || (_cache[13] = _withModifiers((...args) => _unref(nextTrack) && _unref(nextTrack)(...args), ["stop"]))
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })])])])) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("button", {
        class: "music-cat",
        type: "button",
        "aria-expanded": expanded.value,
        "aria-label": expanded.value ? '收起快捷播放器' : '展开快捷播放器',
        onClick: _cache[14] || (_cache[14] = $event => expanded.value = !expanded.value)
      }, [_hoisted_6, _createElementVNode("img", {
        src: _unref(musicCat),
        alt: "戴耳机跳舞的加菲猫"
      }, null, 8, _hoisted_7), _createElementVNode("span", {
        class: _normalizeClass(["playing-dot", {
          active: _unref(isPlaying)
        }])
      }, null, 2)], 8, _hoisted_5)], 2)) : _createCommentVNode("", true)], 64);
    };
  }
};